// @flow

import * as React from 'react';
import { Text } from '../Text';

type ItemProps = {
  id?: string,
  value: string,
  displayText: string,
  children?: React.Node,
};

export class Item extends React.Component<ItemProps> {
  render() {
    return this.props.children !== undefined ? (
      <div>{this.props.children} </div>
    ) : (
      <Text> {this.props.displayText} </Text>
    );
  }
}
